import React, { useState } from 'react';
import { FaLinkedin, FaGithub, FaEnvelope,FaBriefcase} from 'react-icons/fa';
import { motion } from 'framer-motion';

// ---------------- TEAM DATA ----------------
const teamData = [
  {
    name: "Mr. Sawood Ahmed",
    role: "AI Engineer & Full Stack Developer",
    image: "/team/Sawood_img.webp",
    category: ["Founder", "Board Members", "Full-Stack Developer"],
    skills: ["AI", "Leadership", "Engineering"],
    linkedin: "https://linkedin.com/in/sawood",
    github: "https://github.com/sawood",
    email: "sawood.masriqnxttech@gmail.com",
    portfolio: "/sawoodPortfolio",
    description:
      "Visionary AI entrepreneur and technology leader, Sawood Ahmed drives MASRIQ’s innovation, strategic growth, and global partnerships. With deep expertise in artificial intelligence, engineering, and leadership, he empowers the team to deliver transformative digital solutions.",
  },
  {
    name: "Mr. Mohammed Iqlaas",
    role: "AI Engineer & Full Stack Developer",
    image: "/team/Iqlaas_img.webp",
    category: ["Board Members", "Full-Stack Developer"],
    skills: ["Backend Development", "Full Stack Development"],
    linkedin: "https://www.linkedin.com/in/mohammed-iqlaas/",
    github: "https://github.com/Iqlaas1",
    email: "iqlaas.masriqnxttech@gmail.com",
    portfolio: "/iqlaasPortfolio",
    description:
      "COO and full-stack expert, Mohammed Iqlaas ensures operational excellence and technical scalability. His backend development expertise strengthens MASRIQ’s robust platforms and smooth client delivery.",
  },
  {
    name: "Mr. Massoodh Ahmed",
    role: "Chairman",
    image: "/team/Massoodh_img.webp",
    category: "Investors",
    skills: ["Chair Person"],
    linkedin: "https://linkedin.com/in/massoodh",
    github: "",
    email: "massoodh.masriqnxttech@gmail.com",
    portfolio: "/massoodhPortfolio",
    description:
      "Chairman and strategic advisor, Massoodh Ahmed brings decades of business leadership. His vision, mentorship, and guidance ensure MASRIQ’s sustainable growth and innovation in the tech industry.",
  },
  {
    name: "Mr. Roshan Zameer",
    role: "Sleeping Partner",
    image: "/team/Roshan_img.webp",
    category: "Board Members",
    skills: ["Backend Development", "Full Stack Development"],
    linkedin: "https://linkedin.com/in/roshan",
    github: "",
    email: "roshan.masriqnxttech@gmail.com",
    portfolio: "/roshanPortfolio",
    description:
      "Board member and backend specialist, Roshan Zameer contributes technical knowledge and strategic insights. His experience in full stack development adds depth to MASRIQ’s engineering foundation.",
  },
  {
    name: "Mr. Abdul Rahman Mansoori",
    role: "AI Engineer & Full Stack Developer",
    image: "/team/Abdul_img.webp",
    category: ["Board Members", "Full-Stack Developer"],
    skills: ["Design", "UI/UX", "Full Stack Development"],
    linkedin: "https://www.linkedin.com/in/abdul-rahman-mansoori/",
    github: "https://github.com/AbdulRahmanMansoori786",
    email: "abdul.masriqnxttech@gmail.com",
    portfolio: "/abdulPortfolio",
    description:
      "AI Engineer and full stack developer, Abdul Rahman combines AI innovation with UI/UX design expertise. He drives MASRIQ’s product excellence by building user-focused and scalable applications.",
  },
  {
    name: "Ms. Riya Tanwar",
    role: "AI Engineer & Full Stack Developer",
    image: "/team/Riya_img.webp",
    category: ["Board Members", "Full-Stack Developer"],
    skills: ["Design", "UI/UX", "Full Stack Development"],
    linkedin: "https://www.linkedin.com/in/riyatanwar/",
    github: "https://github.com/RiyaTanwar15",
    email: "riya.masriqnxttech@gmail.com",
    portfolio: "/riyaPortfolio",
    description:
      "Full stack developer Riya Tanwar focuses on frontend UI/UX and backend scalability. Her creativity and coding expertise help MASRIQ deliver user-friendly, high-performance digital solutions.",
  },
  {
    name: "Ms. Ayman Fathima",
    role: "Front End Developer",
    image: "/team/Ayman_img.webp",
    category: ["Board Members", "Front-End Developer"],
    skills: ["Design", "UI/UX"],
    linkedin: "https://www.linkedin.com/in/ayman-fathima/",
    github: "https://github.com/ayman-fathima10",
    email: "ayman.masriqnxttech@gmail.com",
    portfolio: "/aymanPortfolio",
    description:
      "Creative frontend developer specializing in UI/UX, Ayman Fathima crafts modern, intuitive interfaces. She ensures seamless user experiences across MASRIQ’s digital platforms.",
  },
  {
    name: "Mr. Mohammed Eisa",
    role: "Front End Developer",
    image: "/team/Eisa_img.webp",
    category: "Front-End Developer",
    skills: ["Design", "UI/UX"],
    linkedin: "https://www.linkedin.com/in/md-eisa-2b7b52258/",
    github: "https://github.com/eisaexe",
    email: "eisa.masriqnxttech@gmail.com",
    portfolio: "/eisaPortfolio",
    description:
      "Frontend developer Mohammed Eisa specializes in UI/UX design. He builds visually appealing and functional web applications, enhancing MASRIQ’s product lineup with user-first interfaces.",
  },
  
];

// ---------------- FILTERS ----------------
const categories = ["All", "Founder", "Board Members", "Investors", "Front-End Developer", "Full-Stack Developer"];
const skills = [
  "All",
  "AI",
  "Design",
  "Leadership",
  "Engineering",
  "UI/UX",
  "Full Stack Development",
  "Frontend Development",
  "Chair Person",
  "Investors",
];

// ---------------- COMPONENT ----------------
const Team = () => {
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedSkill, setSelectedSkill] = useState("All");
  const [flipped, setFlipped] = useState(null);

  const filteredData = teamData.filter((member) => {
    const matchCategory = selectedCategory === "All" || member.category.includes(selectedCategory)
    const matchSkill = selectedSkill === "All" || member.skills.includes(selectedSkill);
    const matchSearch = member.name.toLowerCase().includes(searchTerm.toLowerCase());
    return matchCategory && matchSkill && matchSearch;
  });

  const handleFlip = (index) => {
    if (window.innerWidth < 768) setFlipped(index === flipped ? null : index);
  };

  return (
    <section id="team" className="py-20 px-6 bg-[#0B0C1C] text-white">
      <h2 className="text-4xl font-bold text-center mb-10 bg-gradient-to-r from-cyan-400 to-purple-500 bg-clip-text text-transparent">
        Meet Our Team
      </h2>

      {/* Filters */}
      <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-10 gap-4">
        <div className="flex flex-wrap gap-3 justify-center">
          {categories.map((cat) => (
            <button
              key={cat}
              className={`px-4 py-2 rounded-full font-medium transition text-white/90 hover:bg-cyan-600 ${
                selectedCategory === cat
                  ? "bg-gradient-to-r from-purple-500 to-cyan-400"
                  : "bg-[#1B1D2E]"
              }`}
              onClick={() => setSelectedCategory(cat)}
            >
              {cat}
            </button>
          ))}
        </div>

        <div className="flex gap-3 justify-center mt-3 md:mt-0">
          <input
            type="text"
            placeholder="Search by name..."
            className="p-2 rounded bg-[#1C1E2F] text-white focus:outline-none focus:ring-2 focus:ring-cyan-400"
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <select
            className="p-2 rounded bg-[#1C1E2F] text-white focus:outline-none focus:ring-2 focus:ring-cyan-400"
            onChange={(e) => setSelectedSkill(e.target.value)}
          >
            {skills.map((s) => (
              <option key={s} value={s}>
                {s}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* Team Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-10">
        {filteredData.map((member, index) => (
          <motion.article
            key={index}
            onClick={() => handleFlip(index)}
            className="group perspective"
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <div
              className={`relative w-full h-[370px] transition-transform duration-700 transform-style preserve-3d ${
                flipped === index ? "rotate-y-180" : ""
              } group-hover:rotate-y-180`}
            >
              {/* FRONT */}
              <div className="absolute w-full h-full bg-[#111225] border border-cyan-400 rounded-2xl p-6 shadow-glow backface-hidden flex flex-col items-center justify-center text-center">
                <img
                  src={member.image}
                  alt={`${member.name}, ${member.role} at MASRIQ NextTech Solutions`}
                  className="w-20 h-20 rounded-full object-cover border-2 border-white mb-3"
                />
                <h3 className="text-lg font-bold">{member.name}</h3>
                <p className="text-sm text-cyan-400">{member.role}</p>
              </div>

              {/* BACK */}
              <div className="absolute w-full h-full bg-[#18192C] border border-cyan-400 rounded-2xl p-6 shadow-glow backface-hidden rotate-y-180 flex flex-col items-center justify-center text-center space-y-4">
                <p className="text-sm text-white/90">{member.description}</p>
                <div className="flex flex-wrap gap-2 text-xs justify-center">
                  {member.skills.map((skill) => (
                    <span
                      key={skill}
                      className="px-3 py-1 border border-cyan-400 text-cyan-300 rounded-full"
                    >
                      {skill}
                    </span>
                  ))}
                </div>
                <div className="flex gap-4 text-xl text-white/80 mt-2">
                  {member.linkedin && (
                    <a
                      href={member.linkedin}
                      target="_blank"
                      rel="noreferrer"
                      className="hover:text-cyan-400"
                      aria-label={`${member.name} LinkedIn`}
                    >
                      <FaLinkedin />
                    </a>
                  )}
                  {member.github && (
                    <a
                      href={member.github}
                      target="_blank"
                      rel="noreferrer"
                      className="hover:text-cyan-400"
                      aria-label={`${member.name} GitHub`}
                    >
                      <FaGithub />
                    </a>
                  )}
                  {member.email && (
                    <a
                      href={`mailto:${member.email}`}
                      className="hover:text-cyan-400"
                      aria-label={`Email ${member.name}`}
                    >
                      <FaEnvelope />
                    </a>
                    
                  )}
                  {member.portfolio && (
                    <a
                      href={member.portfolio}
                      className="hover:text-cyan-400"
                      aria-label={`${member.name} Portfolio`}
                    >
                      <FaBriefcase />
                    </a>
                    
                  )}
                </div>
              </div>
            </div>
          </motion.article>
        ))}
      </div>
    </section>
  );
};

export default Team;
